export enum MODAL_CONTENT {
  NOT_QUALIFIED = 'notQualified'
}